module.exports = __webpack_public_path__ + "img/6-1.bda6f43c.png";